import React, {Component} from 'react';
import axios from 'axios';
import LoginItem from "../../components/LoginItem/LoginItem";
import Link from "react-router-dom/es/Link";
import './LoginForm.css'

class LoginForm extends Component {
    constructor(props) {
        super(props);
        document.title = 'Login form';
    }

    state = {
        userName: {
            value: '',
            isValid: true,
            message: ''
        },
        password: {
            value: '',
            isValid: true,
            message: ''
        }
    };

    placeholder = {
        name: "Username",
        password: "Password"
    }

    inputChangeHandler = (event) => {
        const target = event.target;
        const updatedFormElement = {
            ...this.state[target.name]
        };

        let value;
        if (target.type === 'checkbox') {
            value = target.checked
                ? updatedFormElement.value.concat(target.value)
                : updatedFormElement.value.filter(val => val !== target.value);
        } else {
            value = target.value;
        }

        updatedFormElement.value = value;

        this.setState({[target.name]: updatedFormElement});
    };

    validationHandler = (error) => {
        const updatedState = {
            ...this.state
        };

        for (let field in this.state) {
            const updatedFormElement = {
                ...updatedState[field]
            };
            updatedFormElement.isValid = true;
            updatedFormElement.message = '';
            updatedState[field] = updatedFormElement;
        }

        for (let fieldError of error.fieldErrors) {
            const updatedFormElement = {
                ...updatedState[fieldError.field]
            };
            updatedFormElement.isValid = false;
            updatedFormElement.message = fieldError.message;
            updatedState[fieldError.field] = updatedFormElement;
        }

        this.setState(updatedState);
    }

    postDataHandler = (event) => {
        event.preventDefault();

        const formData = {};
        for (let formElementIdentifier in this.state) {
            formData[formElementIdentifier] = this.state[formElementIdentifier].value;
        }

        axios.get('/api/users/me', {

            auth: {
                username: this.state.userName.value,
                password: this.state.password.value
            }

        })
            .then(response => {
                console.log("Logging response:", response);
                localStorage.setItem('user', JSON.stringify(response.data));
                const user = JSON.parse(localStorage.getItem('user'));
                console.log(user.id);
                console.log(user.name);
                console.log(user.role);

                this.props.history.push('/');  //redirect
            })
            .catch(error => {
                console.log(error.response);

                const errors = {
                    fieldErrors: [
                        {
                            field: 'userName',
                            message: 'Invalid username or password'
                        }
                    ]
                }
                this.validationHandler(errors);
            });
    }

    render() {
        const bgStyle = {
            //height: "80vh",
            backgroundImage: "url('../assets/img/wallpaper-tumblr-pc-awesome-yukle-1200x851-travel-background-tumblr-pc-most-beautiful-of-wallpaper-tumblr-pc.jpg')",
            marginTop: "-20px",
            backgroundSize: "cover",
            backgroundPosition: "top center"
        };

        return (
            <div className="page-header header-filter"
                 style={bgStyle}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 ml-auto mr-auto">
                            <div className="card card-login">
                                <form className="form" onSubmit={this.postDataHandler}>

                                    <h3 className="card-title">Login</h3>

                                    <br/>
                                    <div className="card-body">
                                <span className="bmd-form-group">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text">
                                                <i className="material-icons">face</i>
                                            </span>
                                        </div>
                                        <LoginItem
                                            label="Username:"
                                            type="text"
                                            object={this.state.userName}
                                            name="userName"
                                            inputChangeHandler={this.inputChangeHandler}
                                            placeholder={this.placeholder.name}
                                        />
                                    </div>
                                </span>
                                        <span className="bmd-form-group">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text">
                                                <i className="material-icons">lock_outline</i>
                                            </span>
                                        </div>
                                        <LoginItem
                                            label="Password:"
                                            type="password"
                                            object={this.state.password}
                                            name="password"
                                            inputChangeHandler={this.inputChangeHandler}
                                            placeholder={this.placeholder.password}
                                        />
                                    </div>
                                </span>
                                    </div>
                                    <br/>
                                    <button type="submit" className="btn btn-primary">Login</button>
                                    <br/>
                                    <br/>
                                    <Link to={'/resetpassword'} className="">Forgot your password?</Link>
                                </form>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default LoginForm;


// WEBPACK FOOTER //
// ./src/containers/LoginForm/LoginForm.jsx